/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable default-case */
/* eslint-disable prefer-const */
/* eslint-disable no-param-reassign */
import { isPlainObject } from 'lodash';
import qs from 'query-string';
import { env } from '@constants';

let baseURL = '';
const initial = {
  method: 'POST',
  params: null,
  body: null,
  headers: {},
  cache: 'no-cache',
  credentials: 'include',
  responseType: 'JSON',
};

switch (env) {
  case 'local':
  case 'dev':
    baseURL = 'https://api-dev.seel.com';
    break;
  case 'test':
    baseURL = 'https://api-test.seel.com';
    break;
  case 'prod':
    baseURL = 'https://api.seel.com';
    break;
  default:
    baseURL = 'https://api.seel.com';
    break;
}
const basePath = '/gateway/claim-service/api/resolution-center/';

export const request = async (url, config) => {
  if (typeof url !== 'string') throw new TypeError('url must be required and of string type');
  if (!isPlainObject(config)) config = {};
  const { path = basePath, ...rest } = config;
  config = {
    ...initial,
    ...rest,
  };

  let {
    method,
    params,
    body,
    responseType,
  } = config;

  if (!/^http(s?):\/\//i.test(url)) url = baseURL + path + url;
  if (params != null) {
    if (isPlainObject(params)) params = qs.stringify(params);
    url += `${url.includes('?') ? '&' : '?'}${params}`;
  }

  config.headers = {
    ...config.headers,
    'x-request-id': `claim-${Date.now()}`,
  };

  if (isPlainObject(body)) {
    body = JSON.stringify(body);
    config.headers = {
      ...config.headers,
      'Content-Type': 'application/json',
    };
  }

  if (/^(POST|PUT|PATCH)$/i.test(method) && body != null) config.body = body;

  // 发送请求
  return fetch(url, config).then(async (response) => {
    const {
      status,
    } = response;

    // 只要状态码是以2或者3开始的，才是真正的获取成功
    if (status >= 200 && status < 400) {
      let result;
      switch (responseType.toUpperCase()) {
        case 'JSON':
          result = await response.json();
          break;
        case 'TEXT':
          result = await response.text();
          break;
        case 'BLOB':
          result = await response.blob();
          break;
        case 'ARRAYBUFFER':
          result = await response.arrayBuffer();
          break;
      }

      return Promise.resolve(result);
    }

    return Promise.reject({
      originResponse: response,
      originRequest: { url, ...config },
    });
  });
};
